<template>
<section class="whats-news-area pt-50 pb-20">
        <div class="container">
            <div class="row">
            <div class="col-lg-12">
                <div class="row d-flex justify-content-between">
                    <div class="col-lg-3 col-md-12">
                        <div class="section-tittle mb-30">
                            <h3>PHÒNG ĐẤU GIÁ</h3>
                        </div>
                    </div>
                    <div class="col-lg-9 col-md-12">
                        <div class="properties__button">
                            <!--Nav Button  -->                                            
                            <nav>                                                                     
                                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                    <a class="nav-item nav-link active" id="" data-toggle="tab" href="" role="tab" aria-controls="nav-home" aria-selected="true">Tất cả</a>
                                    <a v-for="i in group_assets" :key="i.Id"  class="nav-item nav-link" id="" data-toggle="tab" href="" role="tab" aria-controls="nav-home" aria-selected="true">{{i.NhomTaiSan}}</a>
                                </div>
                            </nav>
                            <!--End Nav Button  -->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <!-- Nav Card -->
                        <div class="tab-content" id="nav-tabContent">
                            <!-- card one -->
                            <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">           
                                <div class="whats-news-caption">
                                    <div class="row">
                                        <!-- <div class="col-lg-4 col-md-6" v-for="i in list_auction_doing" v-on:click="$router.push('/product/auction/'+i.PhienDauGia.Id)"> -->
                                        <div class="col-lg-4 col-md-6" v-for="i in list_auction_doing" :key="i.id">
                                            <a :href="'/product/auction/'+i.PhienDauGia.Id">
                                                <div class="single-what-news mb-120">
                                                    <div class="what-img">
                                                        <img :src="i.DinhKem.length>0? i.DinhKem[0].LinkDownload : ''" alt="">
                                                    </div>
                                                    <div class="what-cap">
                                                        <h4><a class="ellipsis">{{i.TenTaiSan}}</a></h4>
                                                    </div>
                                                    <div class="what-info">
                                                        <div class="icon">
                                                            <img src="@/assets/images/bua.svg" alt="" class="icon-bua">
                                                        </div>
                                                        <div class="text">
                                                            <span>Thời gian bắt đầu:<strong>{{i.PhienDauGia.BatDau | formatDate}}</strong></span>
                                                            <span>Giá khởi điểm:<strong>{{i.GiaKhoiDiem.toLocaleString()}} {{i.PhienDauGia.DonViTinh}}</strong></span>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4 col-md-6" v-for="i in list_auction_do" v-on:click="$router.push('/product/auction/'+i.PhienDauGia.Id)">
                                            <div class="single-what-news mb-120">
                                                <div class="what-img">
                                                    <img :src="i.DinhKem.length>0? i.DinhKem[0].LinkDownload : ''" alt="">
                                                </div>
                                                <div class="what-cap">
                                                    <h4><a class="ellipsis">{{i.TenTaiSan}}</a></h4>
                                                </div>
                                                <div class="what-info">
                                                    <div class="icon">
                                                        <img src="@/assets/images/bua.svg" alt="" class="icon-bua">
                                                    </div>
                                                    <div class="text">
                                                        <span>Thời gian bắt đầu:<strong>{{i.PhienDauGia.BatDau | formatDate}}</strong></span>
                                                        <span>Giá khởi điểm:<strong>{{i.GiaKhoiDiem.toLocaleString()}} {{i.PhienDauGia.DonViTinh}}</strong></span>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Card two -->
                            <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                                <div class="whats-news-caption">
                                    <div class="row">
                                        
                                    </div>
                                </div>
                            </div>
                            <!-- Card three -->
                            <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                                <div class="whats-news-caption">
                                    <div class="row">
                                        
                                    </div>
                                </div>
                            </div>
                            <!-- card fure -->
                            <div class="tab-pane fade" id="nav-last" role="tabpanel" aria-labelledby="nav-last-tab">
                                <div class="whats-news-caption">
                                    <div class="row">
                                        
                                    </div>
                                </div>
                            </div>
                            <!-- card Five -->
                            <div class="tab-pane fade" id="nav-nav-Sport" role="tabpanel" aria-labelledby="nav-Sports">
                                <div class="whats-news-caption">
                                    <div class="row">
                                        
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    <!-- End Nav Card -->
                    </div>
                </div>
            </div>
            </div>
        </div>
    </section>
</template>

<script>
import mixin from '@/mixins/mixin.js'
import { mapGetters } from "vuex";
import moment from 'moment'
import Auction from "@/common/api/auction"
import GroupAssets from "@/common/api/gassets"
import CONFIG from '@/common/config'
import timeDotGov from '@/common/api/time'
export default {
  name: 'AuctionRoom',
  mixins: [mixin],
  data () {
    return {
        group_assets: [],
        list_auction_do: [],
        list_auction_doing: [],
    }
  },
  filters: {
      formatDate: function (value) {
         if (!value) return ''
         return moment(String(value)).format('HH:mm:ss DD/MM/YYYY');
      }
   },
   computed: {
    ...mapGetters(["currentTime"])
  },
  created() {
  },
  mounted(){
     this.getListAuctionDoing()
     this.getListAuctionDo()
     this.GetListGroupAssets()
  },
  methods: {
    GetListGroupAssets(){
        GroupAssets.getList().then(({ data }) => {
            this.group_assets = data.Data;
        })
    },
    gogogo(id){
      this.$router.push("/product/auction/"+id)
    },
    getListAuctionDoing(){
      Auction.getList(CONFIG.ID_AUCTION_DOING)
      .then(({ data }) => {
         this.list_auction_doing = data.Data;
      })
   },
   getListAuctionDo(){
      Auction.getList(CONFIG.ID_AUCTION_DO)
      .then(({ data }) => {
         for (var i = 0; i < data.Data.length; i++){
            let count = new Date(data.Data[i].PhienDauGia.BatDau).getTime() + (7 * 3600000)-this.currentTime
            console.log(new Date(data.Data[i].PhienDauGia.BatDau).getTime(), data.Data[i].PhienDauGia.BatDau, this.currentTime, count )
            if (count<=900000){
               this.list_auction_do.push(data.Data[i])
            }
         }
      })
   }
  },
}
</script>

<style scoped>
.wrap-dot{
   display: -webkit-box !important;
   max-width: 100%;
   margin: 0 auto;
   -webkit-line-clamp: 3;
   -webkit-box-orient: vertical;
   overflow: hidden;
   text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/AuctionRoom.vue